// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"cfdbb0d3","81":"863fa050","82":"85ee1dcc","125":"af59a548","188":"8e2c7ddf","354":"53d18ed4","426":"8bef73fc","440":"ac9d0cd9","502":"5a861ae4","528":"a896b357","546":"95245cc0","664":"cd660ebb","822":"b16b3e7a","837":"5da3f62f","881":"be46469b","954":"1b397b70"}[chunkId] + ".chunk.js";
};